import React from 'react';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';

const PopupCont = styled.div`
    display: block;
    overflow-x: hidden;
    overflow-y: auto;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    outline: 0;
    transition: opacity .15s linear;
    background: rgba(100, 100, 100, 0.5);
`;

const VerticleAlignedCont = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    -moz-transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 100%;
    &.mediaPopup {
        position: fixed;
        top: auto;
        bottom: 0;
        transform: none;
        left: 0;
    }
`;

const ModalOuterCont = styled.div`
    position: relative;
    width: 80%;
    margin: 0 auto;
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-animation-name: zommingEffect;
    -webkit-animation-duration: .3s;
    animation-name: zommingEffect;
    animation-duration: .3s;
    -webkit-transition: -webkit-transform .3s ease-out;
    -o-transition: -o-transform .3s ease-out;
    transition: transform .3s ease-out;

    -webkit-transform: translate(0,-25%);
    -ms-transform: translate(0,-25%);
    -o-transform: translate(0,-25%);
    transform: translate(0,-25%);

    -webkit-transform: translate(0,0);
    -ms-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
`;

const ModalInnerCont = styled.div`
    position: relative;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border-radius: 6px;
    outline: 0;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
    &.modelInnerContCust:before {
        content: '';
        display: block;
        width: 40px;
        height: 4px;
        border-radius: 2px;
        background-color: #d8d8d8;
        position: relative;
        left: 0;
        right: 0;
        margin: auto;
        top: 4px;
        margin-bottom: 0px;
    }
`;

const ModalHeader = styled.div`
    padding: 0;
    border: 0;
    position: relative;
    line-height: 20px;
    vertical-align: middle;
`;

const ModalContent = styled.div`
    margin: 0;
    box-shadow: none;
    margin-top: 0;
    border-radius: 4px;
    padding: 20px 18px;
    background-color: ${COLOR.WHITE};
    &.modelContentCust{
        padding: 16px 20px 20px;
    }
`;

const ModalTitle = styled.h3`
    font-weight: 500;
    padding: 20px 16px;
    font-size: 18px;
    text-align: left;
    color: ${COLOR.BLACK};
    border-bottom: 1px solid ${COLOR.LIGHTGREY};
`;

const ModalCloseIcon = styled.button`
    font-size: 27px;
    line-height: 27px;
    color: #000;
    position: absolute;
    right: 16px;
    top: 16px;
    background: transparent;
    border: 0;
    cursor: pointer;
`;

interface PopupProps {
    title?: string,
    closable?: boolean,
    onClose?: Function,
    content: any,
    style?: any;
}

const SmallPopup: React.FC<PopupProps> = (props: PopupProps) => {

    const onClosePopupClick = () => {
        if (props.onClose) {
            props.onClose();
        }
    }
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (<PopupCont onClick={onClosePopupClick} style={props.style}>
        <VerticleAlignedCont className={isMobile ? "mediaPopup" : ""}>
            <ModalOuterCont className={isMobile ? "w100" : "web-width"} onClick={(e) => e.stopPropagation()}>
                <ModalInnerCont className={isMobile ? "modelInnerContCust" : ""}>
                    {props.title && !isMobile ? <ModalHeader>
                        <ModalTitle>{props.title}</ModalTitle>
                    </ModalHeader> : null}
                    {props.closable ? <ModalCloseIcon onClick={onClosePopupClick}>
                        <span aria-hidden="true">×</span>
                    </ModalCloseIcon> : null}
                    <ModalContent className={isMobile ? "modelContentCust" : ""}>{props.content}</ModalContent>
                </ModalInnerCont>
            </ModalOuterCont>
        </VerticleAlignedCont>
    </PopupCont>)
}

SmallPopup.defaultProps = {
    closable: true
}

export default SmallPopup;